/**
 * @fileoverview Authentication-related configuration.
 * @description Names the storage keys used to persist the access token and the signed-in user
 * (hydrated from the login/MFA-verify response, following up with a GET /identity/me for role/
 * profile fields the verify response no longer carries — see useVerifyTwoFactor.ts), and the
 * pending two-factor challenge (so a mid-flow refresh doesn't lose it). The refresh token is no
 * longer client-storable at all — the identity backend now issues it as an httpOnly cookie, so
 * only the browser ever holds it; see response.interceptor.ts's silent-refresh flow. Where a
 * signed-in user lands after login is no longer a fixed route here — see `resolveHomeRoute`
 * (privilege-dependent, since Sales and Banking are separate modules with no guaranteed common
 * page).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

export const authConfig = {
  accessTokenStorageKey: 'brownbox.auth.accessToken',
  userStorageKey: 'brownbox.auth.user',
  twoFactorChallengeStorageKey: 'brownbox.auth.twoFactorChallenge',
}
